<template>
  <advanced-table
    :headers="headers"
    :filters="filters"
    :sortBy="['created']"
    :sortDesc="[true]"
    :resource="resource"
    :optionLists="optionLists"
  />
</template>

<script>
import AdvancedTable from "@/components/AdvancedTable.vue";
import mixins from "@/mixins/mixins";
import { format } from "date-fns";
export default {
  data() {
    return {
      clickedImei: null,
      headers: [
        {
          text: "מזהה",
          value: "_id",
          align: "start",
          visible: true,
          displayFunc: (data, key) => {
            return data[key] ? data[key] : "לא ידוע";
          },
          linkTo: item => {
            return `/orders/${item._id}`;
          }
        },
        {
          text: "לקוח/ה",
          value: "traveler",
          align: "start",
          visible: true,
          displayFunc: (data, key) => {
            let customer = this.$store.state.entities.customers[data[key]];
            if (customer) {
              return customer.name || "ללא שם";
            }
            return "ללא";
          },
          linkTo: item => {
            return `/customers/${item.traveler}`;
          }
        },
        {
          text: "תאריך התחלה מקורי",
          value: "originalStartDate",
          align: "start",
          visible: false,
          displayFunc: data => {
            return data ? this.heDate(data.originalStartDate) : "לא ידוע";
          }
        },
        {
          text: "תאריך סיום מקורי",
          value: "originalEndDate",
          align: "start",
          visible: false,
          displayFunc: data => {
            return data ? this.heDate(data.originalEndDate) : "לא ידוע";
          }
        },
        {
          text: "תאריך התחלה",
          value: "startDate",
          align: "start",
          visible: true,
          displayFunc: data => {
            return data ? format(data.startDate, "DD/MM/YYYY") : "לא ידוע";
          }
        },
        {
          text: "תאריך סיום",
          value: "endDate",
          align: "start",
          visible: true,
          displayFunc: data => {
            return data ? format(data.endDate, "DD/MM/YYYY") : "לא ידוע";
          }
        },
        {
          text: "סכום",
          value: "totalPayments",
          align: "start",
          visible: true,
          displayFunc: data => {
            return (data.totalPayments / 100).toLocaleString("he-IL", {
              style: "currency",
              currency: "ILS"
            });
          }
        },
        {
          text: "קופון",
          value: "coupon",
          align: "start",
          visible: true,
          displayFunc: (data, key) => {
            let coupon = this.$store.state.entities.coupons[
              data[key] ? data[key]._id || data[key] : null
            ];
            if (coupon) {
              return coupon.name;
            }
            return "ללא";
          }
        },
        {
          text: "אופן איסוף",
          value: "receiveType",
          align: "start",
          visible: true,
          displayFunc: (data, key) => {
            let receiveType = this.$store.state.entities.receiveTypes[
              data[key] ? data[key]._id || data[key] : null
            ];
            if (receiveType) {
              return receiveType.title;
            }
            return "לא ידוע";
          }
        },
        {
          text: "סניף",
          value: "store",
          align: "start",
          visible: true,
          displayFunc: data => {
            if (data.shipmentStore) {
              let store = this.$store.state.entities.stores[
                data.shipmentStore
                  ? data.shipmentStore._id || data.shipmentStore
                  : null
              ];
              if (store) {
                return store.title;
              }
            }
            return "ללא";
          }
        },
        {
          text: "אופן החזרה",
          value: "checkInAgentType",
          align: "start",
          visible: true,
          displayFunc: (data, key) => {
            let returnAgentType = this.$store.state.entities.agentTypes[
              data[key] ? data[key]._id || data[key] : null
            ];
            if (returnAgentType) {
              return returnAgentType.title;
            }
            return "לא ידוע";
          }
        },
        {
          text: "סטטוס",
          value: "status",
          align: "start",
          visible: true,
          displayFunc: (data, key) => {
            let orderStatus = this.$store.state.entities.orderStatuses[
              data[key]
            ];
            if (orderStatus) {
              return orderStatus.title;
            }
            return "לא ידוע";
          }
        },
        {
          text: "מכשיר אומת",
          value: "deviceValidation",
          align: "start",
          visible: true,
          displayFunc: (data, key) => {
            return data[key] === true ? "כן" : "לא";
          }
        },
        {
          text: "משלוח",
          value: "deliveryItem",
          align: "start",
          visible: true,
          displayFunc: (data, key) => {
            return data[key]
              ? data[key].date
                ? this.heDate(data[key].date)
                : "ללא תאריך"
              : "ללא";
          },
          linkTo: item => {
            if (item.deliveryItem) {
              return `/deliveries/${item.deliveryItem.delivery}`;
            }
            return null;
          }
        },
        {
          text: "מכשיר בסניף",
          value: "officeCheckbox",
          align: "start",
          visible: true,
          displayFunc: (data, key) => {
            return data[key] === true ? "כן" : "לא";
          }
        },
        {
          text: "תאריך יצירה",
          value: "created",
          align: "start",
          visible: true,
          displayFunc: (data, key) => {
            return data[key] ? this.heDate(data[key], false, true) : "לא ידוע";
          }
        }
      ],
      filters: [
        {
          type: "DATE",
          label: "נוצרה אחרי",
          model: "createdAfter",
          active: false
        },
        {
          type: "DATE",
          label: "נוצרה לפני",
          model: "createdBefore",
          active: false
        },
        {
          type: "DATE",
          label: "התחלה אחרי",
          model: "startDateAfter",
          active: false
        },
        {
          type: "DATE",
          label: "התחלה לפני",
          model: "startDateBefore",
          active: false
        },
        {
          type: "DATE",
          label: "סיום אחרי",
          model: "endDateAfter",
          active: false
        },
        {
          type: "DATE",
          label: "סיום לפני",
          model: "endDateBefore",
          active: false
        },
        {
          type: "COMBOBOX",
          label: "סטטוס",
          model: "orderStatuses",
          items: "orderStatuses",
          itemText: "title",
          itemValue: "_id",
          active: true
        },
        {
          type: "COMBOBOX",
          label: "אופן איסוף",
          model: "receiveTypes",
          items: "receiveTypes",
          itemText: "title",
          itemValue: "_id",
          active: false
        },
        {
          type: "COMBOBOX",
          label: "חנות איסוף",
          model: "shipmentStores",
          items: "stores",
          itemText: "title",
          itemValue: "_id",
          active: false
        },
        {
          type: "COMBOBOX",
          label: "אופן החזרה",
          model: "checkInAgentTypes",
          items: "agentTypes",
          itemText: "title",
          itemValue: "_id",
          active: false
        },
        {
          type: "COMBOBOX",
          label: "קופון",
          model: "coupons",
          items: "coupons",
          itemText: "name",
          itemValue: "_id",
          active: false
        },
        {
          type: "BOOLEAN",
          label: "מכשיר בסניף",
          model: "officeCheckbox",
          active: false
        },
        {
          type: "BOOLEAN",
          label: "ללא משלוח",
          model: "noDelivery",
          active: false
        },
        {
          type: "TEXT",
          label: "חיפוש",
          model: "search",
          icon: "mdi-magnify",
          expanded: true,
          active: true
        }
      ]
    };
  },
  computed: {
    resource() {
      return this.$store.state.resources["order"];
    },
    orderStatuses() {
      return Object.values(this.$store.state.entities.orderStatuses);
    },
    receiveTypes() {
      return Object.values(this.$store.state.entities.receiveTypes);
    },
    stores() {
      return Object.values(this.$store.state.entities.stores);
    },
    coupons() {
      return Object.values(this.$store.state.entities.coupons);
    },
    agentTypes() {
      return Object.values(this.$store.state.entities.agentTypes);
    },
    optionLists() {
      return {
        orderStatuses: this.orderStatuses,
        receiveTypes: this.receiveTypes,
        stores: this.stores,
        coupons: this.coupons,
        agentTypes: this.agentTypes
      };
    },
    entityEditDialog: {
      get() {
        return this.$store.state.entityEditDialog;
      },
      set(payload) {
        this.$store.commit("TOGGLE_ENTITY_EDIT_DIALOG", payload);
      }
    }
  },
  methods: {
    entityById(entityType, id) {
      return this.$store.getters["entity"](entityType, id);
    }
  },

  watch: {},

  components: {
    AdvancedTable
  },
  mixins: [mixins]
};
</script>